import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Distributor } from '../../shared/models/Distributor';
import { FilterObject } from '../../shared/models/FilterObject';
import { OrderDetail } from '../../shared/models/OrderDetail';
import { Quote} from '../../shared/models/Quote';
import { OrderHistory } from '../../shared/models/OrderHistory';
import { PagingResults } from '../../shared/models/PagingResult';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';
import { ReportParameter, ReportRequestObject } from '../../shared/models/ReportRequestObject';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-quotes',
  templateUrl: './quotes.component.html',
  styleUrls: ['./quotes.component.css']
})
export class QuotesComponent implements OnInit, OnDestroy {
  readonly Page: string = "Quotes";
  QuoteList: Quote[];
  DistList: Distributor[];
  DistSubscription: Subscription;
  CurrentDist: string;
  QuoteSortValue: string;
  HideDist: boolean;
  CurrQuoteDetails: OrderDetail[];
  CurUser: User;
  FilterList: FilterObject[];
  CustFilter: FilterObject;
  PageIndex: number;
  PageSize: number;
  ItemCount: number;
  readonly PageSizeOptions: number[] = [5, 10, 20, 50];
  hideLoadingModal: boolean;
  constructor(private global: GlobalService, private http: HttpService, private router: Router) { }

  ngOnInit(): void {
    this.hideLoadingModal = true;
    this.CurUser = new User();
    this.QuoteSortValue = "orderdate";
    this.PageIndex = 0;
    this.PageSize = 20;
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;

      var dist = this.global.getCurrentDist();
      this.http.PostUserActivity(this.CurUser.UserId.toString(), "Quotes", "Load", "");
      if (!this.CurUser || this.CurUser == null) {
        this.router.navigate(['/']);
      }

      if (this.CurUser.IsTolomaticUser) {
        this.HideDist = false;
      }
      else {
        this.HideDist = true;
      }

      this.CustFilter = new FilterObject();
      this.CustFilter.Key = "customer";

      this.http.GetDistributors().then(x => {
        if (x.StatusCode == "200") {
          this.DistList = x.Content;

          if (dist) {
            if (!this.CurUser.IsTolomaticUser && this.CurUser.DistributorId == dist.CompanyId) {
              this.CurrentDist = dist.CompanyId;
            }
            else if (this.CurUser.IsTolomaticUser) {
              this.CurrentDist = dist.CompanyId;
            }
            else {
              this.CurrentDist = this.CurUser.DistributorId;
            }
          }
          else {
            if (!this.CurUser.IsTolomaticUser && this.CurUser.DistributorId != "") {
              this.CurrentDist = this.CurUser.DistributorId;
            } else {
              this.CurrentDist = this.DistList[0].CompanyId;
            }
          }

          this.CustFilter.Value = this.CurrentDist;
          this.FilterList = [];
          this.FilterList.push(this.CustFilter);
          this.LoadQuotes();
        }

      });
    });
    
    

    this.DistSubscription = this.global.CurrentDist.subscribe(dist => {
      debugger;
      if (dist && dist.CompanyId != this.CurrentDist) {
        this.CurrentDist = dist.CompanyId;
        this.CustFilter.Value = this.CurrentDist;
        this.LoadQuotes();
      }
    });
  }

  ngOnDestroy() {
    if (this.DistSubscription) {
      this.DistSubscription.unsubscribe();
    }
  }

  LoadQuotes() {
    this.hideLoadingModal = false;
    this.http.GetQuotes(this.FilterList, this.CurUser.UserId.toString(), this.PageIndex, this.PageSize,this.QuoteSortValue).then(x => {
      if (x.StatusCode == "200") {
        var results = <PagingResults>x.Content;
        this.QuoteList = results.Items;
        this.ItemCount = results.ItemCount;
        this.QuoteList.forEach(x => {
          x.ShortShipTo = x.ShipToName;
          if (x.ShortShipTo.length > 30) {
            x.ShortShipTo = x.ShortShipTo.substring(0, 27) + "...";
          }
        });
      }
      this.hideLoadingModal = true;
    });
  }

  LoadDetails(custOrder:Quote) {
    if (!custOrder.QuoteDetails) {
      this.hideLoadingModal = false;
      this.http.GetQuoteDetails(custOrder.QuoteNumber, this.CurUser.UserId.toString()).then(x => {
        if (x.StatusCode == "200") {
          custOrder.QuoteDetails = x.Content;
          custOrder.QuoteDetails.forEach(x => {
            x.ShortDesc = x.Description;
            if (x.ShortDesc.length > 55) {
              x.ShortDesc = x.ShortDesc.substring(0, 52) + "...";
            }
          });
        }
        this.hideLoadingModal = true;
      });
    }
  }

  Dist_Change(event: any) {
    //this.CurrentDist = event.value;
    //this.CustFilter.Value = this.CurrentDist;
    var newDist = this.DistList.filter(x => x.CompanyId == event.value)[0];
    this.global.setCurrentDist(newDist);
  }

  QuoteSort_Change(event: any) {
    this.QuoteSortValue = event.value;
    this.LoadQuotes();
  }

  FollowOrder(follow: boolean, orderNum: string) {

  }

  PageEvent(event: any) {
    this.PageIndex = event.pageIndex;
    this.PageSize = event.pageSize;
    this.LoadQuotes();
  }

  SubscribeToUpdates(orderNumber: string) {

  }

  GetQuoteReport(orderNumber: string) {
    this.hideLoadingModal = false;
    var reportRequest = new ReportRequestObject();
    reportRequest.ReportPath = "/SLReports/_TOL_QuoteReport_NonSL";
    var estStarting = new ReportParameter();
    estStarting.Key = "EstimateStarting";
    estStarting.Value = orderNumber;
    var estEnding = new ReportParameter();
    estEnding.Key = "EstimateEnding";
    estEnding.Value = orderNumber;
    this.http.PostUserActivity(this.CurUser.UserId.toString(), "Quotes", "Quote Report",orderNumber);
    reportRequest.ReportParams.push(estStarting);
    reportRequest.ReportParams.push(estEnding);

    this.http.GetSQLReport(reportRequest).subscribe(({ body, headers }: HttpResponse<any>) => {
      debugger;
      var contentType = headers.get('content-type');
      const blob = new Blob([body], { type: contentType });
      var fileURL = URL.createObjectURL(blob);

      var a = document.createElement("a");
      a.href = fileURL;
      a.download = orderNumber + ".pdf";
      a.click();
      this.hideLoadingModal = true;
    });
  }
}
